import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { DataService } from '../services/data.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-notification-bar',
    imports: [CommonModule],
    templateUrl: './notification-bar.component.html',
    styleUrl: './notification-bar.component.scss'
})
export class NotificationBarComponent implements OnInit, OnDestroy {


  notification: {msgType:string, msg: string };
  removeNotificationTimer: any;
  sub: Subscription;

  constructor(private dataService: DataService){}

  ngOnInit(): void {
    this.dataService.notificationBar.subscribe(notification=>{
      this.notification = notification;
      clearTimeout(this.removeNotificationTimer);
      this.removeNotificationTimer = setTimeout(()=>this.notification=null,3000);
    });
  }

  ngOnDestroy(): void {
      this.sub?.unsubscribe();
  }

}
